<template>
	<div class="home">
		<div class="head">
			<div class="head-con"></div>
		</div>
		<div class="mid">
			<div class="mid-head">
				<div class="mid-head-item" v-for="(x, i) in midHead" :key="i + 'midH'" :class="active == x?'active':''" @click="handle(x)">
					<div v-html="x"></div>
				</div>
			</div>
			<div class="mid-title">
				<p>我们的合作伙伴</p>
				<p>信赖，让我们的业务遍布全球</p>
			</div>
			<div class="img-wrap">
				<div class="img" v-for="(x,i) in imgs" :key="i + 'img'">
					<div class="img-box" :class="(i+1) % 3 === 0 ? 'rt' : (i+1) / 4 === 1 ? 'lt' : (i+1) / 5 === 1 ? 'cen' : (i+1) % 2 === 0 ? 'cen' : 'lt'">
						<img :src="x">
					</div>
				</div>
			</div>
			<div class="img-wrap">
				<div class="big-img" v-for="(x,i) in bigImgs" :key="i + 'big'">
					<div class="big-img-box" :class="i % 2 === 0 ? 'lt' : 'rt'"><img :src="x"></div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		data(){
			return{
				active: '预算绩效<br/>管理系统',
				midHead:['预算绩效<br/>管理系统','国库账户<br/>管理系统','银企互联<br/>管理系统','大数据<br/>分&nbsp;&nbsp;&nbsp;析','管理系统<br/>定向开发'],
				imgs:[require('../../assets/images/hzdw9.png'),require('../../assets/images/hzdw7.png'),require('../../assets/images/hzdw5.png'),
				require('../../assets/images/hzdw1.png'),require('../../assets/images/hzdw4.png'),require('../../assets/images/hzdw3.png'),
				require('../../assets/images/hzdw8.png'),require('../../assets/images/hzdw6.png'),require('../../assets/images/hzdw2.png')],
				bigImgs:[require('../../assets/images/hzyh3.png'),require('../../assets/images/hzyh5.png'),require('../../assets/images/hzyh4.png'),require('../../assets/images/hzyh6.png'),require('../../assets/images/hzyh2.png'),require('../../assets/images/hzyh1.png')],
				
			}
		}, 
		methods: {
			handle(val) {
				this.active = val
			}
		}
	}
</script>
<style>
	.touch .home .head .head-con {
		background-image: url(../../assets/images/shouye_touch.png);
	}
	.touch .mid-head-item {
		font-size: 0.4rem;
	}
	.touch .mid-head-item div {
		width: 2rem;
		padding: 0.2rem 0;
		border-radius: 0.1rem;
	}
	.touch .mid-title{
		margin-top: 0.8rem;
	}
	.touch .mid-title>p:nth-child(1){
		font-size: 0.36rem;
	}
	.touch .mid-title>p:nth-child(2){
		font-size: 0.32rem;
		letter-spacing: 0.02rem;
	}
	.touch .img {
		margin-top: 0.4rem;
	}
	.touch .big-img {
		margin-top: 0.4rem;
	}
	.pc .head{
		height: 795px;
	}
	.pc .head .head-con {
		height: 100%;
		width: 1212px;
		background-position: center 0;
		background-repeat: no-repeat;
		background-size: 100%;
	}
	.pc .home .head .head-con {
		background-image: url(../../assets/images/shouye.png);
	}
	.mid-head{
		overflow: hidden;
	}
	.mid-head-item{
		width: 20%;
		text-align: center;
		font-size: 28px;
		font-weight: bold;
		cursor:pointer;
		letter-spacing: 2px;
		float: left;
	}
	.mid-head-item:hover div, .home .active div{
		background:#FFEB3B
	}
	.mid-head-item div{
		width: 224px;
		padding: 20px 0;
		margin: auto;
		border-radius: 5px;
		background: rgba(255,255,255,.3);
	}
	.mid-title{
		margin-top: 65px;
		color: #fff;
		text-align: right;
	}
	.mid-title>p:nth-child(1){
		font-size: 34px;
		font-weight: bold;
	}
	.mid-title>p:nth-child(2){
		font-size: 28px;
		letter-spacing: 2px;
	}
  .img-wrap{
		overflow: hidden;
		text-align: center;
	}
	.img{
		width: 33.33%;
		float: left;
		margin-top: 60px;
	}
	.img-box {
		width: 340px;
		border-radius: 5px;
		background: rgba(255,255,255,.3);
	}
	.img-box>img{
		max-width: 100%;
		display: block;
		margin: auto;
	}
	.big-img{
		width: 50%;
		float: left;
		margin-top: 60px;
	}
	.big-img-box {
		width: 524px;
		border-radius: 5px;
		padding: 10px 0;
		background: rgba(255,255,255,.3);
	}
	.cen {
		margin: 0 auto;
	}
	.lt{
		float: left;
	}
	.rt{
		float: right;
	}
	.big-img-box>img{
		max-width: 100%;
		display: block;
		margin: auto;
	}
</style>